import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('enterapply/list', { params });
  },
  async detail(params: any) {
    return axios.get('enterapply/detail', { params });
  },
  async savedetail(params: any) {
    return axios.post('enterapply/savedetail', qs.stringify(params));
  },
  async audit(params: any) {
    return axios.post('enterapply/audit', qs.stringify(params));
  },
  async close(params: any) {
    return axios.post('enterapply/close', qs.stringify(params));
  },
  async installComplete(params: any) {
    return axios.post('enterapply/install-complete', qs.stringify(params));
  },
  async auditResearchReport(params: any) {
    return axios.post('enterapply/audit-research-report', qs.stringify(params));
  },
};
